import bem from 'utils/bem';

export const blockNavigation = bem('navigation');
